import React from 'react';

const BoardCommentTextarea = (props) => {
  return (
    <section className="BoardCommentTextarea">
      <div className="wrap-commentText">
        <textarea className="comment-textarea" placeholder="답글" name="comment" onChange={props.handleTextChange} value = {props.nowComment}></textarea>
        <p className="comment-btn" onClick = {props.handleSubmit}>저장</p>
      </div>
    </section>
  );
}

export default BoardCommentTextarea;